"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvoList = void 0;
var react_1 = __importStar(require("react"));
var __1 = require("../..");
var js_1 = require("@mdi/js");
var react_2 = __importDefault(require("@mdi/react"));
var react_bootstrap_1 = require("react-bootstrap");
var styled_components_1 = __importDefault(require("styled-components"));
var ConvoDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-bottom: 2px solid grey;\n"], ["\n  border-bottom: 2px solid grey;\n"])));
var ShortedHead = styled_components_1.default.h5(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])));
var Convo = function (_a) {
    var select = _a.select, path = _a.path;
    var _b = (0, __1.useEloise)(), logic = _b.logic, theme = _b.theme;
    var _c = (0, react_1.useState)(), first = _c[0], setFirst = _c[1];
    var _d = (0, react_1.useState)(), value = _d[0], setValue = _d[1];
    logic.hooks.useAsyncEffect(function () { return __awaiter(void 0, void 0, void 0, function () {
        var test, test2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, logic.fb.docs.getUserDoc(path)];
                case 1:
                    test = _a.sent();
                    setValue(test);
                    return [4 /*yield*/, logic.fb.docs.getUserCollection(path + "/messages")];
                case 2:
                    test2 = _a.sent();
                    setFirst(test2[0].data.content);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    var testClick = function () {
        if (select) {
            select(value);
        }
    };
    return (react_1.default.createElement(ConvoDiv, { onClick: testClick }, value && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Row, null,
            react_1.default.createElement(react_bootstrap_1.Col, { lg: 9 },
                react_1.default.createElement(__1.Heading, { size: 3, align: "left" }, value.data.connectedToName)),
            react_1.default.createElement(react_bootstrap_1.Col, { lg: 3 }, value.data.unread && (react_1.default.createElement(react_2.default, { path: js_1.mdiCircle, color: theme.colors[2], size: 1 })))),
        react_1.default.createElement(ShortedHead, { style: { textAlign: "left", color: "grey" } }, first !== null && first !== void 0 ? first : " ")))));
};
var ConvoList = function (_a) {
    var select = _a.select;
    var _b = (0, react_1.useState)(), docs = _b[0], setDocs = _b[1];
    var logic = (0, __1.useEloise)().logic;
    logic.hooks.useAsyncEffect(function () { return __awaiter(void 0, void 0, void 0, function () {
        var test;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, logic.fb.docs.getUserCollection("convos")];
                case 1:
                    test = _a.sent();
                    setDocs(test);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null, docs &&
        docs.map(function (value) { return (react_1.default.createElement(Convo, { select: select, path: "convos/".concat(value.id) })); })));
};
exports.ConvoList = ConvoList;
var templateObject_1, templateObject_2;
